'use client';
const doctors = [
{
  name: 'Médecine Générale',
  role: 'Spécialité Principale',
  text: 'Spécialité clé du centre, répondant à 80% des demandes de consultation. Médecin référent pour le Groupe Cofina et les entreprises partenaires.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1168b0e7c-1772412145587.png",
  alt: 'Médecin généraliste africain en blouse blanche avec stéthoscope dans une clinique moderne'
},
{
  name: 'Pédiatrie & Gynécologie',
  role: 'Spécialités Femme & Enfant',
  text: 'Prise en charge complète de la santé de la femme et de l\'enfant, avec un espace ludique pour réduire le stress des jeunes patients.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_15802f8b2-1769076261401.png",
  alt: 'Pédiatre africaine en blouse blanche souriant avec un enfant patient dans une salle colorée'
},
{
  name: 'Radiologie & Diabétologie',
  role: 'Imagerie & Maladies Chroniques',
  text: 'Plateau technique de pointe pour la radiologie et prise en charge spécialisée du diabète et des maladies métaboliques.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1e2c7ee46-1783512186330.png",
  alt: 'Radiologue africain en blouse blanche examinant des images médicales sur un écran lumineux'
},
{
  name: 'Ophtalmologie, Fibroscopie & ORL',
  role: 'Spécialités Sensorielles',
  text: 'Consultations spécialisées en ophtalmologie, fibroscopie digestive et ORL avec des équipements conformes aux standards internationaux.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_1ec7bf2fe-1772224998501.png",
  alt: 'Ophtalmologue africaine en blouse blanche avec équipement médical spécialisé'
}];


export default function DoctorsSection() {
  return (
    <section id="doctors-1" className="wide-40 py-16">
      <div className="max-w-7xl mx-auto px-4">
        {/* TITLE */}
        <div className="text-center mb-12">
          <h3 className="text-3xl md:text-4xl font-black mb-4" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
            Nos Spécialités Médicales
          </h3>
          <p className="text-gray-500 max-w-xl mx-auto">
            COSA Ananeraie propose un plateau technique pluridisciplinaire avec des spécialistes qualifiés pour répondre à l'ensemble de vos besoins de santé.
          </p>
        </div>

        {/* SPECIALTIES GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          {doctors?.map((doc, i) =>
          <div key={i} className="doctor-1">
              {/* Photo */}
              <div className="hover-overlay text-center">
                <img
                src={doc?.img}
                alt={doc?.alt}
                className="w-full object-cover"
                style={{ height: '280px', objectPosition: 'top center' }} />
              
                <div className="item-overlay"></div>
                <div className="profile-link">
                  <a
                  href="#"
                  className="inline-block border-2 border-white text-white text-xs font-bold uppercase px-4 py-2 rounded transition-all hover:bg-white"
                  style={{ letterSpacing: '0.5px' }}
                  onMouseEnter={(e) => {e.currentTarget.style.color = '#0e5932';}}
                  onMouseLeave={(e) => {e.currentTarget.style.color = '#fff';}}>
                    En Savoir Plus
                  </a>
                </div>
              </div>

              {/* Meta */}
              <div className="doctor-meta">
                <h5 className="font-bold text-base mb-1" style={{ color: '#1d3c5e' }}>{doc?.name}</h5>
                <span className="text-xs font-semibold block mb-2" style={{ color: '#0e5932' }}>{doc?.role}</span>
                <p className="text-xs text-gray-500">{doc?.text}</p>
              </div>
            </div>
          )}
        </div>

        {/* BUTTON */}
        <div className="text-center">
          <a
            href="#"
            className="inline-block px-8 py-3 rounded font-bold text-sm text-white transition-all"
            style={{ backgroundColor: '#0e5932' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0a3f24'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0e5932'}>
            Prendre Rendez-vous
          </a>
        </div>
      </div>
    </section>);
}